module.exports = __webpack_public_path__ + "static/media/icon_20.01b6b366.svg";